module.exports = __webpack_public_path__ + "img/des_tuse_1.008a713a.jpg";